import { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: "A simple widget that truly enhances a website visitors experience. A great tool every website owner should have. Highly recommend.",
      author: "David S.",
      rating: 5
    },
    {
      text: "This thing has made my phone ring off the hook. If you are a service based industry you definitely need to get this thing.",
      author: "Duan B.",
      rating: 5
    },
    {
      text: "Wonderful and refreshing business experience. Software really rocks. Ethics and quality built in America.",
      author: "Don W.",
      rating: 5
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Others Are Saying About Us!
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-gradient-to-br from-orange-50 to-white rounded-2xl p-12 shadow-xl border border-orange-100 min-h-[300px] flex flex-col items-center justify-center">
            <div className="text-center">
              <div className="flex justify-center mb-4">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-2xl mx-1"></i>
                ))}
              </div>
              
              <p className="text-xl md:text-2xl text-gray-700 italic mb-8 leading-relaxed">
                "{testimonials[currentIndex].text}"
              </p>
              
              <p className="text-lg font-semibold text-gray-900">
                {testimonials[currentIndex].author}
              </p>
            </div>

            <div className="flex justify-center gap-3 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentIndex
                      ? 'bg-orange-500 w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
